import { useContext } from 'react';
import { ButtonsRight } from '../../../../interfaces/UI';
import { ReferencesContext } from '../../../../context';
import { ReferenceCard } from './ReferenceCard';

interface Props {
    openButtons : ButtonsRight,
    setOpenButtons :  (button : ButtonsRight) => void
}

export const References = ({ openButtons, setOpenButtons }: Props) => {
  const { reference } = useContext(ReferencesContext);

  return (
    <div id="option-9" className={`aside__content ${openButtons.optReferences?"active":""}`}>
      <div className="aside__content-header">
        <h3>Referencias</h3>
        <button className="btn btn-rounded btn-rounded-transparent btn-close" onClick={() => {
          setOpenButtons({...openButtons, optReferences: false})
        }}>
          <span className="btn__icon"><i className="icon icon-vpro-close"></i></span>
        </button>
      </div>
      <div className="aside__content-data main-sb">
        {reference && (<ReferenceCard reference={reference}/>)}
      </div>
    </div>
  )
}